module.exports = __webpack_public_path__ + "img/La_vie_en_rose.caaefe0.jpg";